export const STORY_STEP_TYPES = {
  DIALOGUE: 'dialogue',
  NARRATION: 'narration',
  CHOICE: 'choice',
  REMEMBER: 'remember',
  HOMEWORK: 'homework',
};

export const StoryStepTypes = [
  STORY_STEP_TYPES.DIALOGUE,
  STORY_STEP_TYPES.NARRATION,
  STORY_STEP_TYPES.CHOICE,
  STORY_STEP_TYPES.HOMEWORK,
  STORY_STEP_TYPES.REMEMBER,
];

interface IStoryStep {
  _type: typeof StoryStepTypes[number],
  _key: string,
}

export interface IStoryDialogue extends IStoryStep {
  speakerId: number
  text: string
}

export interface IStoryNarration extends IStoryStep {
  text: string
}

export interface IStoryChoice extends IStoryStep {
  choiceOptions: IStoryOption[]
  skill?: string,
}

export interface IStoryRemember extends IStoryStep {
  content: string
}

export interface IStoryHomework extends IStoryStep {
  content: string
}

export interface IStoryOption {
  text: string
  correct: boolean
  feedbackContent: string
}

export interface IStory {
    _id: string; //document id
  
    metaTitle: string;
    metaDescription: string;
  
    ordinal: number;
    name: string;
    headingContextText: string;
    category: string; //siteCategory
    storyIdentifier: string;
  
    speaker1Image?: string;
    speaker2Image?: string;
    speaker1Thumbnail?: string;
    speaker2Thumbnail?: string;
    storySelectorImage?: string;
    characterName?: string;
    speaker1ImageThumbnailPosition?: string;
    speaker2ImageThumbnailPosition?: string;
    storyImage?: string;
  
    storySteps: (
      | IStoryDialogue
      | IStoryNarration
      | IStoryChoice
      | IStoryRemember
      | IStoryHomework
    )[];
  
    versionTags: string[];
  }
  